var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Id } from "core/utils";
import { DisplayMode } from "core/codegen/types";
import { renderContentBlocks } from "contentBlock";
import { BlockLists } from "./Blocklists";
import { mq } from "core/styles/snippets";
var getBlockList = function (program) {
    var _a;
    if (program.slug.includes("/tien-om-te-zien") && program.embed !== null) {
        return BlockLists.Totz;
    }
    if (program.slug.includes("/code-van-coppens") && program.embed !== null) {
        return BlockLists.CodeVanCoppens;
    }
    if (program.slug.includes("/the-voice-van-vlaanderen") && program.embed !== null) {
        return BlockLists.TheVoiceVanVlaanderen;
    }
    if (program.embed && ((_a = program.embed) === null || _a === void 0 ? void 0 : _a.displayMode) !== DisplayMode.Slot) {
        return BlockLists.FullScreenEmbed;
    }
    if (program.variant === "vtmgo") {
        return BlockLists.Vtmgo;
    }
    return BlockLists.Default;
};
export var View = function (_a) {
    var program = _a.program;
    return (React.createElement(ProgramStyled, { "data-result": Id.result.success, "data-uuid": program.uuid, "data-component": Id.component.program }, renderContentBlocks(getBlockList(program), program)));
};
var ProgramStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  > * {\n    margin-bottom: 2rem !important;\n\n    ", " {\n      margin-bottom: 3rem !important;\n    }\n\n    ", " {\n      margin-bottom: 3.5rem !important;\n    }\n\n    ", " {\n      margin-bottom: 5rem !important;\n    }\n  }\n"], ["\n  width: 100%;\n\n  > * {\n    margin-bottom: 2rem !important;\n\n    ", " {\n      margin-bottom: 3rem !important;\n    }\n\n    ", " {\n      margin-bottom: 3.5rem !important;\n    }\n\n    ", " {\n      margin-bottom: 5rem !important;\n    }\n  }\n"])), mq.minWidth("64rem"), mq.minWidth("90rem"), mq.minWidth("120rem"));
var templateObject_1;
